import { EXPORT_FPS, FRAME_DURATION } from './exportFrameTiming';

export type IntervalDragMode = 'start' | 'end' | 'move';

export interface ApplyIntervalDragInput {
  mode: IntervalDragMode;
  initialStart: number;
  initialEnd: number;
  deltaSec: number;
  fullVideoDuration: number;
  minDuration?: number;
}

export function applyIntervalDrag({
  mode,
  initialStart,
  initialEnd,
  deltaSec,
  fullVideoDuration,
  minDuration = FRAME_DURATION,
}: ApplyIntervalDragInput): { startTime: number; endTime: number } {
  const first = Math.round(initialStart * EXPORT_FPS);
  const last = Math.round(initialEnd * EXPORT_FPS);
  const limit = Math.floor(fullVideoDuration * EXPORT_FPS + 1e-7);
  const minimum = Math.max(1, Math.ceil(minDuration * EXPORT_FPS));
  if (mode === 'start') {
    const frame = Math.round((initialStart + deltaSec) * EXPORT_FPS);
    return { startTime: Math.max(0, Math.min(frame, last - minimum)) / EXPORT_FPS, endTime: initialEnd };
  }
  if (mode === 'end') {
    const frame = Math.round((initialEnd + deltaSec) * EXPORT_FPS);
    return { startTime: initialStart, endTime: Math.min(limit, Math.max(frame, first + minimum)) / EXPORT_FPS };
  }
  const duration = Math.max(1, last - first);
  const frame = Math.round((initialStart + deltaSec) * EXPORT_FPS);
  const start = Math.max(0, Math.min(frame, limit - duration));
  return { startTime: start / EXPORT_FPS, endTime: (start + duration) / EXPORT_FPS };
}
